<div class="banner">
	<div class="flex container ">
		<div class="flex content-container">
			<h1 class="text-accent-lighter">{{'landing-page.middle_banner_title' | translateWithKeys}}</h1>
			<p class="text-accent-lighter">{{'landing-page.middle_banner_description' | translateWithKeys}}</p>
			<button class="text-accent-dark menu-items-background-color" mat-stroked-button (click)="joinNow()">{{'landing-page.banner_join_btn'| translateWithKeys}}</button>
		</div>
		<div class="img-container">
			<img class="middle-image-banner" src="../../../../assets/images/middle_banner.png" alt="middle-banner">
		</div>
	</div>
</div>
